// /**
//  * 前端多语言解决方案
//  */
// import _ from 'underscore';
// import url from 'c-url';
// import LangPack from './pack';
//
// let lang = url.query('lang');
// let tws = ['zh-SG', 'zh-MO', 'zh-TW', 'zh-HK'];
// let ars = [
//     'ar-AE',
//     'ar-BH',
//     'ar-DZ',
//     'ar-EG',
//     'ar-IQ',
//     'ar-JO',
//     'ar-KW',
//     'ar-LB',
//     'ar-LY',
//     'ar-MA',
//     'ar-OM',
//     'ar-QA',
//     'ar-SA',
//     'ar-SY',
//     'ar-TN',
//     'ar-YE'
// ];
// if (!lang) {
//     let systemLanguage = navigator.language || navigator.browserLanguage;
//     let _systemLanguage = systemLanguage.toLowerCase();
//
//     switch (_systemLanguage) {
//         case 'ar':
//             systemLanguage = 'ar-EG';
//             break;
//         case 'vi':
//             systemLanguage = 'vi-VN';
//             break;
//         case 'en':
//             systemLanguage = 'en-US';
//             break;
//         case 'ja':
//             systemLanguage = 'ja-JP';
//             break;
//         case 'zh':
//             systemLanguage = 'zh-CN';
//             break;
//         default:
//             break;
//     }
//
//     let arr = systemLanguage.split('-');
//
//     if (arr.length > 1) {
//         systemLanguage = arr[0] + '-' + arr[1].toUpperCase();
//     } else {
//         systemLanguage = 'en-US';
//     }
//
//     if (systemLanguage == 'zh-CN' || systemLanguage == 'ja-JP' || systemLanguage == 'vi-VN') {
//         lang = systemLanguage;
//     } else if (tws.indexOf(systemLanguage) >= 0) {
//         lang = 'zh-TW';
//     } else if (ars.indexOf(systemLanguage) >= 0) {
//         lang = 'ar-EG';
//     } else {
//         lang = 'en-US';
//     }
// }
//
// let langType = lang.replace('-', '').toLowerCase();
// let langPack = LangPack[langType] || LangPack['enus'];
//
// let _lang = {
//
//     type: lang,
//
//     init: function() {
//         $('html').attr('lang', lang);
//         $('body').addClass(langType);
//         return this;
//     },
//
//     template: function(tplStr, data, insertEM){
//         let tpl = langPack[tplStr] || tplStr;
//         if (tpl) {
//             if (tpl.indexOf('@@@@') > 0) {
//                 let strArr = [];
//
//                 strArr.push('<ul>');
//                 tpl.split('@@@@').forEach(function(item, index){
//                     item && strArr.push('<li>' + item + '</li>');
//                 });
//                 strArr.push('</ul>');
//                 tpl = strArr.join('');
//             }
//             if (insertEM) {
//                 tpl = tpl.replace(/<%=([\s\S]+?)%>/g, function($0, $1){
//                     return '<em class="' + $1 +'">' + $0+ '</em>';
//                 });
//             }
//             return _.template(tpl)(data);
//         } else {
//             return _.template(tplStr)(data);
//         }
//     }
// };
//
// module.exports = _lang.init();
/**
 * 前端多语言解决方案
 */
import Url from 'c-url';

const LangUtil = function() {
    this.initialize.apply(this, arguments)
}

LangUtil.prototype = {
    /**
     * @return zh-CN、zh-TW、zh-HK、ar-EG、vi-VN、ja-JP
     */
    lang: '',
    /**
     * @return zhcn、zhtw、zhhk、areg、vivn、jajp
     */
    langType: '',
    /**
     * 支持的语言列表
     */
    languages: ['en-US'],
    /**
     * 初始化化入口
     */
    initialize: function(cfg) {
        let LangPack = cfg.LangPack || {};
        let lang = cfg.lang || this.getLanguage();
        let langType = lang.replace('-', '').toLowerCase();

        $('html').attr('lang', lang);
        $('body').addClass(langType);

        this.lang = lang;

        this.pack = LangPack[langType] || LangPack['enus'];

        this.langType = langType;
    },
    /**
     * 获取语言。优先级：URL配置 > 系统语言 > 默认语言
     */
    getLanguage: function() {
        if (Url.query('lang')) { // 配置页面语言
            return Url.query('lang');
        } else if (Url.query('_lang')){
            return Url.query('_lang');
        } else if (window.g_Language) { // 系统浏览器语言
            return window.g_Language;
        } else {
            return this.languages[0]; // 若没有，获取第一个活动语言。
        }
    },
    /**
     * 渲染模版内容
     * @param tplStr模版内容
     * @param data 数据
     * @splitWidthEM  默认false
     */
    template: function(tplStr, data, insertEM) {
        let tpl = (this.pack && this.pack[tplStr] || tplStr) + '';
        insertEM = (typeof insertEM == 'undefined') ? false : true;

        if (!tpl) {
            return '';
        }

        // for 活动规则。段落分隔符号：@@@@
        if (tpl.indexOf('@@@@') >= 0) {
            let strArr = [];

            strArr.push('<ul>');
            tpl.split('@@@@').forEach(function(item, index) {
                item && strArr.push('<li>' + item + '</li>');
            });
            strArr.push('</ul>');
            tpl = strArr.join('');
        }

        tpl = tpl.replace(/\{([\s\S]+?)\}/ig, function($0, $1) {
            if (insertEM) {
                return '<em class="' + $1 + '">' + data[$1] + '</em>';
            } else {
                return data[$1];
            }
        });

        tpl = tpl.replace(/\<\%\=([\s\S]+?)\%\>/ig, function($0, $1) {
            if (insertEM) {
                return '<em class="' + $1 + '">' + data[$1] + '</em>';
            } else {
                return data[$1];
            }
        });

        return tpl;
    }
}

export default LangUtil;


// WEBPACK FOOTER //
// ./js/lang/index.js